import React from "react";
import { Link } from "react-router-dom";
import {
    Navbar,
    Container
} from "reactstrap";

const HeaderNavbar = (props) => {
    return (
        <>
            <Navbar className="navbar-top navbar-dark mt-4" expand="md" id="navbar-main">
                <Container fluid>
                    <Link
                        className="h2 mb-0 text-white d-none d-md-inline-block"
                        to={props.path}
                    >
                        {props.pageName}
                    </Link>
                </Container>
            </Navbar>
        </>
    );
};

export default HeaderNavbar;
